import Vue from 'vue';
import store from '../store';
import * as Sentry from '@sentry/vue';

// pre-populate everything thats is needed reactive right from the start!
const state =
{
    locale: '',
    account: {
        availability: {
            deadline: '',
            editable: false,
            constraints: false,
            vacation: false,
        },
        setup: 1
    },
    accounts: {},
    location: null,
    membership: {},
    user: {},
};

const actions =
{
    init ({commit}, data)
    {
        commit('INIT', data);
    },

    reset ({commit})
    {
        commit('RESET');
    },

    updateGravatar ({commit}, image)
    {
        commit('UPDATE_GRAVATAR', image);
    },

    updateLocale ({commit}, data)
    {
        commit('UPDATE_LOCALE', data);
    },

    updateModules ({commit}, data)
    {
        commit('UPDATE_MODULES', data);
    },

    addModule ({commit}, identifier)
    {
        commit('ADD_MODULE', identifier);
    },

    removeModule ({commit}, identifier)
    {
        commit('REMOVE_MODULE', identifier);
    },

    updateUser ({commit}, data)
    {
        commit('UPDATE_USER', data);
    },

    updateMembership ({commit}, data)
    {
        commit('UPDATE_MEMBERSHIP', data);
    },

    updateLocation ({commit}, data)
    {
        commit('UPDATE_LOCATION', data);
    },

    updateAccount ({commit}, data)
    {
        commit('UPDATE_ACCOUNT', data);
    },

    updatePreference ({commit}, payload)
    {
        commit('UPDATE_PREFERENCE', payload);
    },

    updateCheckin ({commit}, payload)
    {
        commit('UPDATE_CHECKIN', payload);
    }
};

const mutations =
{
    INIT (state, data)
    {
        state.locale = data.current.locale;
        state.account = data.current.account;
        state.accounts = data.current.accounts;
        state.location = data.current.location;
        state.membership = data.current.membership;
        state.user = data.current.user;
        state.profile = data.current.profile;

        if (state.locale != store.state.meta.lang)
        {
            // user's language preference differs from current language
            store.dispatch('meta/setLanguage', state.locale, { root: true });

            Vue.onduro.switchLanguage(state.locale, true); // replace route
        }

        if (Sentry)
        {
            Sentry.setContext('app', 
            {
                user: data.current.user.name,
                account: data.current.account.name,
            });

            Sentry.setTag('version', process.env.VERSION);
        }
    },

    RESET (state)
    {
        state.location = null;
        state.membership = {};
        state.user = {};
    },

    UPDATE_LOCALE (state, locale)
    {
        state.locale = locale;
    },

    UPDATE_GRAVATAR (state, image)
    {
        state.user.gravatar = image;
    },

    UPDATE_MODULES (state, data)
    {
        state.account.modules = data;
    },

    ADD_MODULE (state, identifier)
    {
        if (state.account.modules.indexOf(identifier) == -1)
        {
            state.account.modules.push(identifier);
        }
    },

    REMOVE_MODULE (state, identifier)
    {
        let key = state.account.modules.indexOf(identifier);

        if (key !== -1)
        {
            Vue.delete(state.account.modules, key);
        }
    },

    UPDATE_USER (state, data)
    {
        Object.assign(state.user, data);
    },

    UPDATE_MEMBERSHIP (state, data)
    {
        Object.assign(state.membership, data);
    },

    UPDATE_ACCOUNT (state, data)
    {
        Object.assign(state.account, data);
    },

    UPDATE_LOCATION (state, data)
    {
        state.location = data;
    },

    UPDATE_PREFERENCE (state, payload)
    {
        state.membership.preferences[payload.identifier] = payload.value;
    },

    UPDATE_CHECKIN (state, payload)
    {
        state.membership.checkedIn = payload;
    },
};

export default
{
    namespaced: true,
    state,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/js/vuex/modules/current.js